export enum IdType {
    sa_identity = 'sa_identity',
    sa_passport = 'sa_passport',
    drivers_license = 'drivers_license',
    asylum_permit = 'asylum_permit',
    foreign_passport = 'foreign_passport',
    verification_image = 'verification_image',
}
